"use strict";

angular
	.module('rmUser')
	.factory('User', require('./user.js'));